import React from 'react';

import PageLayout from 'PageLayout';
import { EButton, EPageTitle, ETable } from 'libs/ui';
import { getRole } from 'utils/routeUtility';

import useAdminAccounts from './Hooks/useAdminAccounts';

export default function AdminAccount() {

    const {
        navigate,
        isLoading,
        accountList
    } = useAdminAccounts();

    return (
        <PageLayout>
            <EPageTitle
                title="Available Accounts"
                end={
                    getRole()?.includes("AFFILIATE")
                        ?
                        <></>
                        :
                        <EButton
                            onClick={() => navigate("/admin/accounts/create")}
                        >Create New</EButton>
                }
            />
            <ETable
                loading={isLoading}
            >
                <thead>
                    <tr>
                        <th>Bank Name</th>
                        <th>Bank Address</th>
                        <th>Branch</th>
                        <th>Account Number</th>
                        <th>Account Name</th>
                        <th>IFSC Code</th>
                        <th>System Code</th>
                        {/* <th>Challan Id</th> */}
                        <th>MIC Number</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        accountList.map((each, index) => (
                            <tr key={index + "_acc"}>
                                <td>{each.bankName ?? "-"}</td>
                                <td>{each.bankAddress ?? "-"}</td>
                                <td>{each.branch ?? "-"}</td>
                                <td>{each.accountNumber ?? "-"}</td>
                                <td>{each.accountName ?? "-"}</td>
                                <td>{each.ifsccode ?? "-"}</td>
                                <td>{each.systemCode ?? "-"}</td>
                                {/* <td>{each.challanId ?? "-"}</td> */}
                                <td>{each.micnumber ?? "-"}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </ETable>
        </PageLayout>
    )
}